/* eslint-disable prefer-destructuring */
/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line no-undef
// localhost http://localhost:1337/
// livehost https://ss-backend.herokuapp.com/

const HOST = process.env.GATSBY_HOST;

export const API = {
  register: `${HOST}register`,
  login: `${HOST}auth/login`,
  googleAuth: `${HOST}auth/google`,
  facebookAuth: `${HOST}auth/facebook`,
  emailVerify: `${HOST}email/verify`,
  resetPassword: `${HOST}password/reset`,
  getUserDetail: `${HOST}user/getdetails`,
};
